export const zh = {
  poweredByFirst: "由智能語音助理",
  poweredBySecond: "EVAS提供",
  name: "病患姓名",
  gender: "性別",
  age: "年齡",
  recordNo: "病歷號碼",
  from: "病患來源",
  ward: "病房",
  examDate: "檢查日期",
  examTime: "檢查時間",
  examItem: "檢查項目",
  applicationDate: "申請日期",
  applicationTime: "申請時間",
  applicationDr: "申請醫師",
  reportTime: "報告時間",
  reportDate: "報告日期",
  vs: "主治醫師",
  examDr: "檢查醫師",
  nurse: "跟診護士",
  technician: "技術員",
  Sigmoidoscopy: "乙狀結腸鏡檢查報告",
  Colonoscopy: "大腸鏡檢查報告",
  Gastroscopy: "胃鏡檢查報告",
  ColonoscopyCheckNo: "大腸鏡檢查",
  GastroscopyCheckNo: "胃鏡檢查",

  // ColonCloeanseForm
  indication: "適應症(檢查原因)",
  complication: "併發症",
  sedatives: "止痛鎮靜藥物",
  premedication: "檢查前藥物",
  antiPlatelet: "抗凝血藥物",
  preparationTime: "清腸時間",
  preparationAgent: "清腸用藥",
  cleanseLevel: "清腸程度(檢查前)",
  cleanseLevelAfter: "清腸程度(檢查後)",
  scopeId: "內視鏡型號",
  washingMachine: "洗滌機型號",
  informedConsent: "同意書",
  insertionTime: "插入時間",
  withdrawTime: "退出時間",
  totalExamTime: "總時長",
  proximalColonWithTime: "近端退出時間",
  insertionLevel: "伸入最深位置",
  insertionLength: "伸入最深長度",
  incompleteStudy: "未完成檢查原因",
  additionalRemarks: "其他標記",

  // Colon finding
  finding: "發現",
  findings: "發現",
  lesion: "病灶",
  summary: "總結",
  suggestion: "醫師建議",
  other: "其他",
  procedureNote: "檢查說明",
  procedureImages: "檢查照片",
  additionalImage: "其他照片",

  http: {
    error: {
      400: "發生不正確的請，請聯繫開發人員",
      401: "未經授權的訪問，請重新登入",
      403: "無訪問權限，請聯絡管理人員",
      404: "請求路徑無效，請聯繫開發人員",
      405: "不允許的函式",
      406: "Http協議錯誤，伺服器端未允許 Accept-Charset 以及 Accept-Language，請聯繫開發人員",
      408: "請求逾時，請檢查裝置的網路連線",
      500: "Server端發生錯誤",
      502: "Server透過代理或匝道請求時，發生不明錯誤",
      503: "Server端無法處理目前連線的請求，請稍後再嘗試",
      504: "Server透過代理或匝道請求逾時",
      505: "HTTP Version Not Supported",
      999: "JavaScript發生錯誤",
    },
  },
};
